import React, { useEffect } from 'react';
import { Column, Title, Box } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCashRegister, faDonate, faParking, faMobileAlt } from "@fortawesome/free-solid-svg-icons";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import { faTelegramPlane } from "@fortawesome/free-brands-svg-icons";
import { Link } from 'react-router-dom';
import Layout from "../layout";
import AppService from '../../services/app';
import PdvService from '../../services/pdv';
import DistributorBalances from '../../components/components/DistributorBalances';

const firstsLinks = [
  //{ link: "/users/find", icon: faUsersCog, color: "has-text-custom-purple", title: 'Usuários', size: 4 },
  { link: "/app/find", icon: faMobileAlt, color: "has-text-custom-purple", title: 'App', size: 4 },
  { link: "/pdv/find", icon: faCashRegister, color: "has-text-custom-purple", title: 'PDV', size: 4 },
  { link: "/notifications", icon: faTelegramPlane, color: "has-text-custom-purple", title: 'Notificações', size: 4 },
]

const secondsLinks = [
  { link: "/questions", icon: faQuestionCircle, color: "has-text-custom-purple", title: 'Perguntas', size: 4 },
  { link: "/dashbord", icon: faParking, color: "has-text-grey", title: 'Estacionamento', size: 4 },
  //{ link: "/amc", icon: faUniversity, color: "has-text-custom-purple", title: 'AMC', size: 3 },
  //{ link: "/dashbord", icon: faCartPlus, color: "has-text-grey", title: 'Compras', size: 3 },
  { link: "/dashbord", icon: faDonate, color: "has-text-grey", title: 'Financeiro', size: 4 },
]

const DashbordScreen = () => {
  useEffect(() => {
    AppService.cleanAppCache();
    PdvService.cleanPdvCache();
  }, [])

  return (
    <Layout>
      <Column.Group vcentered>
        {
          firstsLinks.map((firstLink, index) => (
            <Column>
              <Link to={firstLink.link}>
                <Box textAlign="centered">
                  <FontAwesomeIcon icon={firstLink.icon} size="3x" className={firstLink.color} /*spin={(index===0)}*/ />
                  <Title subtitle size={firstLink.size} className={firstLink.color}>{firstLink.title}</Title>
                </Box>
              </Link>
            </Column>
          ))
        }
      </Column.Group>

      <Column.Group vcentered>
        {
          secondsLinks.map((secondLink, index) => (
            <Column>
              <Link to={secondLink.link}>
                <Box textAlign="centered">
                  <FontAwesomeIcon icon={secondLink.icon} size="3x" className={secondLink.color} /*spin={(index===0)}*/ />
                  <Title subtitle size={secondLink.size} className={secondLink.color}>{secondLink.title}</Title>
                </Box>
              </Link>
            </Column>
          ))
        }
      </Column.Group>
      <DistributorBalances />
    </Layout>
  )

}

export default DashbordScreen;
